export default __webpack_public_path__ + "783b19d708e8b74a6eb1742902e8b1d4.png";